export const environment = {
  production: true,
  dataHostLive: 'https://mongo-db-rest-api-1.c1i44.now.sh',
  dataHostDev: 'http://localhost:3050',
  lookupKey: {
    getAllRecords: '1d963791-5450-4275-a614-7349b54df552',
    postContact: '33183092-929b-44b4-9d7e-d2a8b3a98ead',
    deleteContact: '2033695f-12c5-477c-9be0-30319f3242ea',
    upsertContact: 'a6824247-ba78-4031-b04b-f2a7e980d3dd'
  }
};
